import { c as _c } from "react/compiler-runtime";
import { IcoCamera40 } from '@onefootprint/icons';
import { motion } from 'framer-motion';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import type { IdDocImageSide } from '@/idv2/features/collect-document/types';
import HeaderTitle from '../../../components/header-title';
import IdDocPhotoButtons from '../../../components/id-doc-photo-buttons';
import type { ReceivedImagePayload } from '../../../types';
import { isSelfie } from '../../../utils/capture';
type MobileFallbackUploadViewProps = {
  imageType: `${IdDocImageSide}`;
  title: string;
  subtitle: string;
  hasBadConnectivity: boolean | undefined;
  allowPdf: boolean;
  allowUpload: boolean;
  onBack: () => void;
  onComplete: (payload: ReceivedImagePayload) => void;
};
const MobileFallbackUploadView = t0 => {
  const $ = _c(21);
  const {
    imageType,
    title,
    subtitle,
    hasBadConnectivity,
    allowPdf,
    allowUpload,
    onBack,
    onComplete
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 1,
      transition: {
        duration: 0.3
      }
    };
    t3 = {
      opacity: 0
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onBack) {
    t4 = <NavigationHeader leftButton={{
      variant: "back",
      onBack
    }} position="floating" />;
    $[3] = onBack;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== subtitle || $[6] !== title) {
    t5 = <HeaderTitle title={title} subtitle={subtitle} icon={IcoCamera40} display="flex" flexDirection="column" />;
    $[5] = subtitle;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== allowUpload || $[9] !== imageType) {
    t6 = isSelfie(imageType) || !allowUpload;
    $[8] = allowUpload;
    $[9] = imageType;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isSelfie(imageType) ? "user" : "environment";
  let t8;
  if ($[11] !== allowPdf || $[12] !== hasBadConnectivity || $[13] !== onComplete || $[14] !== t6 || $[15] !== t7) {
    t8 = <IdDocPhotoButtons onComplete={onComplete} allowPdf={allowPdf} hideUploadButton={t6} nativeCameraFacingMode={t7} isNativeCameraCapture={true} uploadFirst={true} hasBadConnectivity={hasBadConnectivity} fallbackUpload={true} />;
    $[11] = allowPdf;
    $[12] = hasBadConnectivity;
    $[13] = onComplete;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t8) {
    t9 = <FlexColumnMotionContainer initial={t1} animate={t2} exit={t3}>{t4}{t5}{t8}</FlexColumnMotionContainer>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export const FlexColumnMotionContainer = t0 => {
  const $ = _c(6);
  let children;
  let motionProps;
  if ($[0] !== t0) {
    ({
      children,
      ...motionProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = motionProps;
  } else {
    children = $[1];
    motionProps = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== motionProps) {
    t1 = <motion.div className="flex flex-col justify-center items-center flex-1 h-full gap-4 p-4" {...motionProps}>{children}</motion.div>;
    $[3] = children;
    $[4] = motionProps;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default MobileFallbackUploadView;